<script>
const excludedPages = [
    '/sign-up',
    '/sign-in',
    '/recover-password',
    '/reset-password',
    '/renew-membership',
    '/trial-upgrade',
    '/sign-out',
];

/**
 * Adding this component to the page will cause all links to display the upgrade modal popup
 */
export default {
    name: 'ForceUpgradeModal',

    mounted() {
        if (this.isExcludedPage()) {
            return;
        }

        // We listen for click instead of ontouchstart because ontouchstart is too sensitive and passive by default
        document.body.addEventListener('click', this.handleClick);
    },

    beforeDestroy() {
        document.body.removeEventListener('click', this.handleClick);
    },

    methods: {
        isExcludedPage() {
            const currentPage = window.location.pathname;
            return !!excludedPages.find(page => currentPage.startsWith(page));
        },

        handleClick(e) {
            // Find the link that the user clicked on
            const link = e.composedPath().find(el => el.tagName && el.tagName.toLowerCase() === 'a');
            if (!link) {
                return;
            }

            // If we have an element with data-one-click-exclude in the tree, don't show the popup
            const excluder = link.closest('[data-one-click-exclude]');
            if (excluder) {
                const category = excluder.dataset.oneClickExclude || null;
                // Navigation is a special case
                if (category && category !== 'navigation') {
                    return;
                }
            }

            e.preventDefault();
            this.$root.showPopup('upgradeModal', {continueUrl: link.getAttribute('href')});
        },
    },

    render() {
        return null;
    },
}
</script>
